@if (canView) {
    <div class="flex flex-col gap-4 text-sm">
        <div class="font-bold sm:pt-0 text-ponder-light">
            <span class="text-base">Tasks</span>
        </div>
        <div class="flex flex-row gap-2">
            <div class="flex flex-col gap-2">
                <!-- Tasks -->
                <div class="flex flex-col">
                    <loading [isLoading]="loadingTasks" [success]="loadingTasksSuccess"></loading>
                    @if (!loadingTasks && loadingTasksSuccess && taskDescriptions && taskSummaries) {
                        <div class="flex flex-col gap-1">
                            @for (taskDescription of taskDescriptions ; track taskDescription.taskName) {
                                <task-summary-row (click)="onTaskRowClicked(taskDescription)" [taskName]="taskDescription.taskName" [taskSummaries]="taskSummaries" class="bg-slate-100 hover:bg-white hover:cursor-pointer" [ngClass]="{'bg-white' : (selectedTask == taskDescription)}"></task-summary-row>
                            }
                        </div>
                    }
                </div>
            </div>
            <div class="flex flex-col grow">
                @if (selectedTask) {
                    <task-display [task]="selectedTask"/>
                }
            </div>
        </div>
    </div>
} @else {
    <admin-unauthorized></admin-unauthorized>
}
<task-view></task-view>